import type { LegalDocument } from '../../domain/entities/LegalDocument';
import type { HashGenerator } from '../../application/ports/HashGenerator';

/**
 * Generates SHA-256 hash of legal document content
 * This hash is stored in Supabase to verify document integrity
 */
const generateDocumentHash = async (document: LegalDocument): Promise<string> => {
  const contentToHash = {
    id: document.id,
    version: document.version,
    sections: document.sections,
  };

  const encoder = new TextEncoder();
  const data = encoder.encode(JSON.stringify(contentToHash));
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};

/**
 * Creates HashGenerator implementation using Web Crypto API
 */
export const createWebCryptoHashGenerator = (): HashGenerator => ({
  generateHash: generateDocumentHash,
});
